import imageCompression from "browser-image-compression";
import { FileWithMetadata } from "components";
import { MediaDirectoryKeys, MediaType } from "constants/enums";
import { getFileFromRemoteMedia } from "helpers";
import { DirectUploadMedia, DirectUploadToS3Options } from "libs/directUpload";

import { ProductVariantFormValue } from "../components";

export const getProductFormVariantsWithDefaultPreviewIds = async (
  variants: ProductVariantFormValue[],
  defaultValuesVariants: ProductVariantFormValue[],
  uploader: (
    file: FileWithMetadata,
    options: DirectUploadToS3Options
  ) => Promise<DirectUploadMedia | undefined>
) => {
  return await Promise.all(
    variants.map(async (variant) => {
      const actualVariantImageForDefaultPreview = variant.images.find(
        (image) => image.mediaType === MediaType.IMAGE
      ) as DirectUploadMedia;

      const previousVariantImages = defaultValuesVariants.find(
        (beforeUpdateVariant) => variant.id === beforeUpdateVariant.id
      )?.images;

      const isFirstImageAlreadyUploaded = previousVariantImages?.some(
        (image) => image.id === actualVariantImageForDefaultPreview.id
      );

      if (isFirstImageAlreadyUploaded) {
        return {
          ...variant,
          compressedPreviewId:
            variant.compressedPreview?.id ??
            actualVariantImageForDefaultPreview.id
        };
      }

      try {
        const fileToCompress = await getFileFromRemoteMedia(
          actualVariantImageForDefaultPreview
        );
        const compressedDefaultPreviewFile = await imageCompression(
          fileToCompress,
          {
            maxSizeMB: 0.1,
            maxWidthOrHeight: 2000,
            fileType: "image/webp",
            // Ceiling, not a target — see useImagesCompressor.
            initialQuality: 1
          }
        );
        const defaultPreviewMedia = await uploader(
          compressedDefaultPreviewFile,
          {
            directoryKey: MediaDirectoryKeys.ProductVariant
          }
        );

        return {
          ...variant,
          compressedPreviewId: defaultPreviewMedia?.id ?? ""
        };
      } catch (error) {
        // oxlint-disable-next-line no-console
        console.error(
          "Failed to regenerate compressed preview, falling back to existing one",
          error
        );
        return {
          ...variant,
          compressedPreviewId:
            variant.compressedPreview?.id ??
            actualVariantImageForDefaultPreview.id
        };
      }
    })
  );
};
